import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 1,
  class: "common-layout"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_header = _resolveComponent("nav-header")
  const _component_side_bar = _resolveComponent("side-bar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_a_config_provider = _resolveComponent("a-config-provider")

  return (_ctx.$route.name && _ctx.$route.name !== 'login')
    ? (_openBlock(), _createBlock(_component_a_config_provider, {
        key: 0,
        locale: _ctx.zh_CN
      }, {
        default: _withCtx(() => [
          _createVNode(_component_nav_header),
          _createVNode("section", null, [
            _createVNode(_component_side_bar, { "nav-links": _ctx.navLinks }, null, 8, ["nav-links"]),
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["locale"]))
    : (_openBlock(), _createBlock("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]))
}